import {
  COLLECTIONS_LOAD_EXTERNAL_DATABASE_BEGIN,
  COLLECTIONS_LOAD_EXTERNAL_DATABASE_SUCCESS,
  COLLECTIONS_LOAD_EXTERNAL_DATABASE_FAILURE,
  COLLECTIONS_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function loadExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_EXTERNAL_DATABASE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}appwrites/${args.dbCollectionUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_LOAD_EXTERNAL_DATABASE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalDatabaseError() {
  return {
    type: COLLECTIONS_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        loadExternalDatabasePending: true,
        loadExternalDatabaseError: null,
      };

    case COLLECTIONS_LOAD_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        loadExternalDatabasePending: false,
        loadExternalDatabaseError: null,
        externalDatabase: action.data,
      };

    case COLLECTIONS_LOAD_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        loadExternalDatabasePending: false,
        loadExternalDatabaseError: action.data.error,
      };

    case COLLECTIONS_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
